import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const metaMap = {
  "/": {
    title: "Party Packages | Corporate Party Places, Cocktail Party Bar, Pubs",
    description: "Book party packages at top venues for birthdays, cocktails, and corporate events in Delhi NCR.",
  },
  "/feed": {
    title: "Party Packages | Corporate Party Places, Cocktail Party Bar, Pubs",
    description: "Book party packages at top venues for birthdays, cocktails, and corporate events in Delhi NCR.",
  },
  "/artist-page": {
    title: "PartyWitty - Our Artists",
    description: "Explore PartyWitty's top-rated artists and performers.",
  },
  "/club-about-us": {
    title: "PartyWitty - Club About Us",
    description: "Learn more about PartyWitty and our club offerings.",
  },
  "/BookATableViewAll": {
    title: "PartyWitty - Book a Table",
    description: "Reserve tables instantly at clubs, bars, and restaurants with exclusive deals.",
  },
  "/events": {
    title: "Book Events & Celebrations in Delhi NCR – Top Venues & Deals",
    description: "Looking for event booking in Delhi NCR? Discover top venues, curated packages, and best deals for birthdays, weddings, and corporate events.",
  },
  "/venues": {
    title: "Instant Table Booking – Deals on Clubs & Restaurants Nearby",
    description: "Reserve tables online at top party venues in Delhi-NCR. Get amazing offers on clubs, cafes, and restaurants with PartyWitty’s easy booking.",}
};


const MetaHead = () => {
  const location = useLocation();
  const meta = metaMap[location.pathname] || {
    title: "PartyWitty",
    description: "Discover clubs, events, and party packages in Delhi NCR.",
  };

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
    </Helmet>
  );
};

export default MetaHead;
